import React, { useEffect } from 'react'
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Auth } from "aws-amplify";
import awsmobile from "../../aws-exports";
import { addMinutes } from "date-fns";
import { Link, useLocation } from "react-router-dom";
// Layout
import { AuthLayout } from "../../layouts/AuthLayout";
import {
  useNotify,
  useTranslate,
  useAuthState,
  useRedirect,
  useAuthProvider,
  useDataProvider,
} from "react-admin";
import {
  Input,
  Button,
  CircularProgress,
  Typography,
  Box,
  makeStyles,
} from "@material-ui/core";
import { LimitExpirationPassword } from './components/LimitExpirationPassword';
import { LoaderApp } from "../../components/layout/LoaderApp";

const useStyles = makeStyles((theme) => ({
  title: {
    color: "#2D4050",
    fontWeight: "bold",
    marginBottom: 5,
    textAlign: "center",
  },
  contentText: {
    color: "#888888",
    fontWeight: "normal",
    fontSize: 16,
    margin: 0,
    marginBottom: 25,
    textAlign: "center",
  },
}));

export default function ChangePasswordTemporal() {
  const translate = useTranslate();
  const classes = useStyles();
  const notify = useNotify();
  const location = useLocation();
  const redirect = useRedirect();
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [isChangePassword, setIsChangePassword] = useState(false)
  const { adminSetNewPassword, logout } = useAuthProvider();
  const { register, handleSubmit, watch } = useForm();
  const { validatePassword, registerPassword, updateChangePassword } = useDataProvider();

  const [passwordUpdate, setPasswordUpdate] = useState("")

  const handleChangePassword = (data, event) => {
    event.preventDefault();
    setIsChangePassword(false)
    setBtnSubmit("loading");
    if (data.newPassword !== data.conPassword) {
      setBtnSubmit(true);
      notify("ra.notification.password_not_same_error", "warning");
    } else {
      if (location.state) {
        const { auth } = location.state
        let dataParams = {}
        let isProcess = false;
        if (auth.attributes) {
          dataParams = {
            "email": auth.attributes['email'],
            "password": data.newPassword,
            "business_id": auth.attributes['custom:business']
          }
          isProcess = true;
        } else {
          if (auth.challengeParam.userAttributes) {
            dataParams = {
              "email": auth.challengeParam.userAttributes['email'],
              "password": data.newPassword,
              "business_id": auth.challengeParam.userAttributes['custom:business']
            }
            isProcess = true;
          } else {
            notify("ra.notification.password_temporal_not_process", 'error');
            setBtnSubmit(true);
          }
        }
        if (isProcess) {
          validatePassword(dataParams)
            .then((res) => {
              setBtnSubmit(true);
              setIsChangePassword(true)
              setPasswordUpdate(data.newPassword);
            })
            .catch((err) => {
              const errRes = err.error;
              if (errRes.includes("The minimum password length is 8 characters")) {
                notify(translate("ra.errorChangePassword.minimum_characters"), 'error');
              } else if (errRes.includes("Password cannot contain institution name")) {
                notify(translate("ra.errorChangePassword.containts_name_institution"), 'error');
              } else if (errRes.includes("The password cannot contain three consecutive identical characters")) {
                notify(translate("ra.errorChangePassword.containts_three_consecutive"), 'error');
              } else if (errRes.includes("Password must have at least one letter")) {
                notify(translate("ra.errorChangePassword.have_one_letters"), 'error');
              } else if (errRes.includes("Password must have at least one number")) {
                notify(translate("ra.errorChangePassword.have_one_number"), 'error');
              } else if (errRes.includes("Password must have at least one special character")) {
                notify(translate("ra.errorChangePassword.have_special_character"), 'error');
              } else if (errRes.includes("The password cannot contain blank spaces")) {
                notify(translate("ra.errorChangePassword.have_blank_spave"), 'error');
              } else if (errRes.includes("La contraseña no debe ser la misma que las 5 últimas utilizadas")) {
                notify(translate("ra.errorChangePassword.repeat_password"), 'error');
              } else {
                notify(err.error, 'error');
              }
              setBtnSubmit(true);
            })
          isProcess = false;
        } else {
          notify("ra.notification.password_temporal_not_process", 'error');
          setBtnSubmit(true);
        }
      } else {
        notify("ra.notification.password_temporal_not_found", "warning");
        setBtnSubmit(true)
        setIsChangePassword(true)
      }
    }
  };

  const updateAttributesUsers = (valueDays, pin) => {
    setBtnSubmit("loading");
    if (location.state) {
      const { username, password, auth } = location.state
      //console.log(username, password)
      if (username !== undefined && password !== undefined) {
        try {
          //const auth = await Auth.signIn(username, password);
          if (
            (auth.challengeName &&
              auth.challengeName === "NEW_PASSWORD_REQUIRED") || (auth.attributes['custom:password_update'] === undefined
                || auth.attributes['custom:password_update'] === "0" || auth.attributes['custom:password_update'] === 0)
          ) {
            if (auth.attributes) {
              updatePassw(username, passwordUpdate, auth, valueDays, pin)
            } else {
              if (auth.challengeParam.userAttributes) {
                updatePassw(username, passwordUpdate, auth, valueDays, pin)
              } else {
                notify("ra.notification.password_temporal_not_found", "warning");
                setBtnSubmit(true)
              }
            }
          } else {
            if (auth.attributes) {
              const totalExpirationDate = Number(auth.attributes['custom:password_update']) + Number(auth.attributes['custom:password_expiry_time']);
              let currentDate = new Date().getTime();
              if(currentDate > totalExpirationDate || !auth.attributes['custom:pin_bancaribe']) {
                updatePassw(username, passwordUpdate, auth, valueDays,pin)
              } else {
                notify("ra.notification.password_temporal_not_found", "warning");
                setBtnSubmit(true)
              }
            } else {
              notify("ra.notification.password_temporal_not_found", "warning");
              setBtnSubmit(true)
            }
          }
        } catch (err) {
          notify("ra.notification.password_temporal_not_process", "warning");
          setBtnSubmit(true)
        }
      } else {
        notify("ra.notification.password_temporal_not_found", "warning");
        setBtnSubmit(true)
      }
    } else {
      notify("ra.notification.password_temporal_not_found", "warning");
      setBtnSubmit(true)
      setIsChangePassword(true)
    }
  }


  const updatePassw = (username, password, auth, valueDays, pin) => {
    let currentDate = new Date();
    var days_milliseconds = Number(valueDays) * 24 * 60 * 60 * 1000;
    let attributes = {}
    if (auth.attributes) {
      attributes = auth.attributes
    } else if (auth.challengeParam.userAttributes) {
      attributes = auth.challengeParam.userAttributes
    }
    let params = {
      username: username,
      password: password,
      pool_id: awsmobile.aws_user_pools_id,
      data: [
        { Name: "email", Value: username },
        { Name: "name", Value: attributes['name'] },
        { Name: "custom:last_name", Value: attributes['custom:last_name'] },
        { Name: "custom:business", Value: attributes['custom:business'] },
        { Name: "custom:branch_id", Value: attributes['custom:branch_id'] },
        { Name: "custom:role", Value: attributes['custom:role'] },
        { Name: "custom:password_update", Value: currentDate.getTime().toString() },
        { Name: "custom:password_expiry_time", Value: days_milliseconds.toString() },
        { Name: "custom:pin_bancaribe", Value: pin.toString() }
      ],
    };
    updateChangePassword(params)
      .then((res) => {
        logout().then((res) => {
          redirect("/login")
        })
        notify(translate("ra.auth.success_change_password"), "success")
      })
      .catch((err) => {
        const errRes = err.error;
        notify(errRes, "warning")
        setBtnSubmit(true)
      })
    //redirect("/login")
  }

  useEffect(() => {
  }, [btnSubmit])


  return (
    <>
      {
        btnSubmit === "loading" && (
          <LoaderApp />
        )
      }
      <AuthLayout>
        {
          !isChangePassword ? (
            <form
              style={{ width: "95%", maxWidth: 410 }}
              onSubmit={handleSubmit(handleChangePassword)}
            >
              <Typography variant="h5" className={classes.title}>
                {translate("ra.auth.title")}
              </Typography>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gridGap="22px"
                width="100%"
                margin="0 auto"
                marginTop="20px"
                maxWidth="410px"
              >
                <Input
                  fullWidth
                  placeholder={translate("ra.auth.newPasswordField")}
                  type="password"
                  style={{ padding: "22px 28px" }}
                  {...register("newPassword", { required: true })}
                  disableUnderline={true}
                  required={true}
                />
                <Input
                  fullWidth
                  placeholder={translate("ra.auth.newPasswordConfirmField")}
                  type="password"
                  style={{ padding: "22px 28px" }}
                  {...register("conPassword", { required: true })}
                  disableUnderline={true}
                  required={true}
                />
                <Button
                  fullWidth
                  type="submit"
                  variant={btnSubmit === "loading" ? "outlined" : "contained"}
                  color="primary"
                  style={{ margin: 55, marginBottom: 16, borderRadius: '10px' }}
                  size="large"
                  disabled={
                    watch("conPassword") === undefined || watch("conPassword") === ""
                      ? true
                      : false
                  }
                >
                  {btnSubmit === "loading" ? (
                    <CircularProgress color="primary" size="1.5rem" />
                  ) : (
                    translate("ra.action.continue")
                  )}
                </Button>
                <Link
                  to="/login"
                  style={{ width: "100%", textDecoration: "none" }}
                >
                  <Button fullWidth variant="outlined" color="inherit" size="large">
                    {translate("ra.action.goBack")}
                  </Button>
                </Link>
              </Box>
            </form>
          ) : (
            <LimitExpirationPassword updateAttributesUsers={updateAttributesUsers} />
          )
        }
      </AuthLayout>


    </>

  );
}


